import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CalendarDays } from "lucide-react";
import { whatsappLink } from "@/data/content";

const WaIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}><path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1-.2.3-.8.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.5-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.7-.7 2-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.3zM12 21.8c-1.8 0-3.5-.5-5-1.4l-.4-.2-3.7 1 1-3.6-.2-.4c-1-1.6-1.5-3.4-1.5-5.2C2.2 6.6 6.6 2.2 12 2.2c2.6 0 5.1 1 6.9 2.9 1.8 1.8 2.9 4.3 2.9 6.9 0 5.4-4.4 9.8-9.8 9.8zM20.5 3.5C18.2 1.2 15.2 0 12 0 5.4 0 0 5.4 0 12c0 2.1.6 4.2 1.6 6L0 24l6.2-1.6c1.8 1 3.8 1.5 5.8 1.5 6.6 0 12-5.4 12-12 0-3.2-1.2-6.2-3.5-8.4z" /></svg>
);

export default function FloatingActions() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const on = () => setShow(window.scrollY > 500);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3 sm:bottom-8 sm:right-8">
      <motion.div initial={false} animate={{ opacity: show ? 1 : 0, y: show ? 0 : 16, pointerEvents: show ? "auto" : "none" }} transition={{ duration: 0.5 }}>
        <Link to="/contact" className="btn-gold !px-5 !py-3 shadow-[0_16px_40px_-12px_rgba(11,26,47,.6)]" data-testid="floating-book-btn"><CalendarDays className="h-4 w-4" /><span className="hidden sm:inline">Book Consultation</span><span className="sm:hidden">Book</span></Link>
      </motion.div>
      <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" aria-label="Chat with Immistop on WhatsApp" data-testid="floating-whatsapp-btn" className="group relative flex h-14 w-14 items-center justify-center rounded-full border border-gold/50 bg-navy text-gold shadow-[0_16px_40px_-12px_rgba(11,26,47,.7)] transition-transform duration-500 hover:scale-105">
        <span className="absolute inset-0 rounded-full border border-gold/40 animate-ping [animation-duration:3s]" />
        <WaIcon className="h-6 w-6" />
      </a>
    </div>
  );
}
